












































































































































































import Accordion from "@/components/shared/Accordion.vue";
import Draggable from "vuedraggable";
import { getMultiStoreId, getStoreId } from "@/services/AuthService";
import { ShipmentService } from "@/services/ShipmentService";
import { SearchMetadataDto } from "@/model/data.model";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    MbeAccordion: Accordion,
    draggable: Draggable
  }
})
export default class ExportShipments extends Vue {
  templates: SearchMetadataDto[] = [];
  templateSelected = "";
  titleTemplate = "Default template";

  counterTemplateTypes: any[] = [];
  list: any[] = [];
  defaultList: any[] = [];
  isDefault = true;
  isExistingTemplate = true;
  responseObj: any;
  isAlreadyAName = false;
  names: string[] = [];

  created() {
    ShipmentService.getExportShipTrace(
      this.$store.getters["customer/info"].customerId
    ).then((res: any) => {
      this.responseObj = res;
      const presetsTypes = [];
      for (let i = 0; i < res.presets.length; i++) {
        presetsTypes.push(res.presets[i].field);
        this.list.push(res.presets[i]);
        this.defaultList.push(res.presets[i]);
      }
      this.counterTemplateTypes = presetsTypes.map(value => {
        return { value: value, label: this.$i18n.t(String(value)) } as any;
      });
    });
    this.handleSearch("");
  }
  isTitleUsable() {
    if (this.isExistingTemplate) {
      this.isAlreadyAName = false;
    } else {
      if (this.titleTemplate === "") {
        this.isAlreadyAName = true;
      } else {
        const searchInput = this.titleTemplate.toLowerCase();
        ShipmentService.queryMetadataCurrentUser(25, 0, null, searchInput).then(
          (res: any) => {
            let isAName = false;
            for (let i = 0; i < res.content.length; i++) {
              if (res.content[i].context === "shipments-" + searchInput) {
                isAName = true;
              }
            }
            this.isAlreadyAName = isAName;
          }
        );
      }
    }
  }
  returnDefault() {
    this.isExistingTemplate = true;
    this.list = this.defaultList;
    this.titleTemplate = "Default template";
    this.templateSelected = null;
    this.isDefault = true;
    this.isTitleUsable();
  }

  loadTemplate() {
    this.isExistingTemplate = true;

    if (this.templateSelected === "") {
      this.list = this.defaultList;
      this.titleTemplate = "Default template";
      this.isDefault = true;
    } else {
      this.list = [];
      this.titleTemplate = this.templateSelected;

      const presetsTypes = [];
      let ind = 0;
      for (let k = 0; k < this.templates.length; k++) {
        if (this.templates[k].context === "shipments-" + this.templateSelected)
          ind = k;
      }
      if (this.templates[ind].presets.length === undefined) {
        this.list.push(this.templates[ind].presets);
      }
      for (let i = 0; i < this.templates[ind].presets.length; i++) {
        this.list.push(this.templates[ind].presets[i]);
      }
      this.isDefault = false;
    }
    this.isTitleUsable();
  }

  deleteElement(item: any) {
    this.list.splice(this.list.indexOf(item), 1);
  }
  addElement() {
    const obj = {
      editable: this.defaultList[0].editable,
      field: this.defaultList[0].field,
      group: this.defaultList[0].group,
      type: this.defaultList[0].type,
      visible: this.defaultList[0].visible
    };
    this.list.push(obj);
  }
  newTemplate() {
    this.list = [];
    this.isDefault = false;
    this.templateSelected = "Load template";
    this.titleTemplate = "";
    this.isExistingTemplate = false;
    this.isTitleUsable();
  }
  saveTemplate() {
    const presets = JSON.parse(JSON.stringify(this.list));
    this.responseObj.presets = presets;
    this.responseObj.username = this.$store.getters.user.username;
    this.responseObj.storeId = getStoreId();
    this.responseObj.multistoreId = getMultiStoreId();

    const titleTemplateInput = "shipments-" + this.titleTemplate.toLowerCase();
    ShipmentService.createOrUpdateMetadataFor(
      "shipments",
      titleTemplateInput,
      this.responseObj
    ).then((res: any) => {
      this.handleSearch("");
      this.templateSelected = this.titleTemplate;
      this.returnDefault();
    });
  }

  copyTemplate() {
    this.titleTemplate = this.titleTemplate + " Copy";
    this.isDefault = false;
    this.isExistingTemplate = false;
    this.isTitleUsable();
  }

  deleteTemplate() {
    const titleTemplateInput = "shipments-" + this.titleTemplate.toLowerCase();

    ShipmentService.deleteMetadataFor(
      "shipments",
      titleTemplateInput,
      this.$store.getters["customer/info"].tenantId
    ).then((res: any) => {
      this.isDefault = true;
      this.list = this.defaultList;
      this.titleTemplate = "Default template";
      this.handleSearch("");
    });
  }

  handleSearch(search: any) {
    this.templateSelected = search;
    if (search === "") {
      ShipmentService.queryMetadataCurrentUser(10, 0, null, "").then(
        (res: any) => {
          this.templates = [];
          this.names = [];
          for (let i = 0; i < res.content.length; i++) {
            this.templates.push(res.content[i]);
            this.names.push(
              res.content[i].context.substring(10, res.content[i].length)
            );
          }
        }
      );
    }
    if (search === undefined || search.length < 3) {
      return;
    }
    const searchInput = search.toLowerCase();
    ShipmentService.queryMetadataCurrentUser(10, 0, null, searchInput).then(
      (res: any) => {
        this.templates = [];
        this.names = [];
        for (let i = 0; i < res.content.length; i++) {
          this.templates.push(res.content[i]);
          this.names.push(
            res.content[i].context.substring(10, res.content[i].length)
          );
        }
      }
    );
  }
}
